const EmptySearchIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 69 47'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M47.1606 45.8242C49.635 45.8242 52.0086 44.8505 53.759 43.1192C55.5075 41.3861 56.4909 39.0359 56.4909 36.5859C56.4909 30.145 56.4909 20.855 56.4909 14.4141C56.4909 11.9641 55.5075 9.61385 53.759 7.88075C52.0086 6.1495 49.635 5.17578 47.1606 5.17578C37.2293 5.17578 19.7704 5.17578 9.83915 5.17578C7.36474 5.17578 4.99109 6.1495 3.24072 7.88075C1.49221 9.61385 0.508789 11.9641 0.508789 14.4141C0.508789 20.855 0.508789 30.145 0.508789 36.5859C0.508789 39.0359 1.49221 41.3861 3.24072 43.1192C4.99109 44.8505 7.36474 45.8242 9.83915 45.8242H47.1606ZM11.7052 36.5859H28.4999C29.5299 36.5859 30.3659 35.7582 30.3659 34.7383C30.3659 33.7184 29.5299 32.8906 28.4999 32.8906H11.7052C10.6751 32.8906 9.83915 33.7184 9.83915 34.7383C9.83915 35.7582 10.6751 36.5859 11.7052 36.5859ZM11.7052 27.3477H45.2945C46.3246 27.3477 47.1606 26.5199 47.1606 25.5C47.1606 24.4801 46.3246 23.6523 45.2945 23.6523H11.7052C10.6751 23.6523 9.83915 24.4801 9.83915 25.5C9.83915 26.5199 10.6751 27.3477 11.7052 27.3477ZM11.7052 18.1094H45.2945C46.3246 18.1094 47.1606 17.2816 47.1606 16.2617C47.1606 15.2418 46.3246 14.4141 45.2945 14.4141H11.7052C10.6751 14.4141 9.83915 15.2418 9.83915 16.2617C9.83915 17.2816 10.6751 18.1094 11.7052 18.1094Z'
        fill='#D2D2D2'
      />
      <path
        d='M46.1426 18.5938C47.5233 18.5938 48.6426 17.4745 48.6426 16.0938C48.6426 14.713 47.5233 13.5938 46.1426 13.5938V18.5938ZM46.1426 13.5938L27.1426 13.5938V18.5938H46.1426V13.5938Z'
        fill='white'
      />
      <path
        d='M45 27.5C46.3807 27.5 47.5 26.3807 47.5 25C47.5 23.6193 46.3807 22.5 45 22.5L45 27.5ZM45 22.5L29 22.5L29 27.5L45 27.5L45 22.5Z'
        fill='white'
      />
      <g clipPath='url(#clip0_1385_1455)'>
        <path
          d='M42.6304 33.2267C51.1798 33.2267 58.1104 26.3498 58.1104 17.8667C58.1104 9.38362 51.1798 2.50671 42.6304 2.50671C34.081 2.50671 27.1504 9.38362 27.1504 17.8667C27.1504 26.3498 34.081 33.2267 42.6304 33.2267Z'
          stroke='#00BA9F'
          strokeWidth='4'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M64.9251 43.7664C65.7092 44.5444 66.9755 44.5395 67.7535 43.7554C68.5315 42.9713 68.5266 41.705 67.7425 40.927L64.9251 43.7664ZM52.0854 31.0263L64.9251 43.7664L67.7425 40.927L54.9028 28.1869L52.0854 31.0263Z'
          fill='#00BA9F'
        />
      </g>
      <defs>
        <clipPath id='clip0_1385_1455'>
          <rect width='44' height='45' fill='white' transform='translate(25)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmptySearchIcon;
